import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container mt-5 text-center" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createVNode("h1", { class: "mb-5" }, "Questions? Need help?")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("p", null, "If you have any questions regarding the Design System, ask!", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, "You can ask either Karim, Christopher or Julie.", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("a", {
  class: "btn btn-primary mt-4",
  href: "https://teams.microsoft.com/l/team/19%3a77a92f5fcab9491c89fd81b9dbf1f547%40thread.tacv2/conversations?groupId=59e0d1a3-35f2-4e28-ac37-008235ad2e0f&tenantId=ead5a9b8-4a2d-4d79-b8f5-3beff6730b27"
}, " Open Iceberg Teams channel ", -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5
  ]))
}